/* eslint-disable no-nested-ternary */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-use-before-define */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-restricted-syntax */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-alert */
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
import { DialogUtility, DialogComponent } from '@syncfusion/ej2-react-popups';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import { Tooltip } from '@syncfusion/ej2-popups';
import { DashboardLayoutComponent, PanelDirective, PanelsDirective } from '@syncfusion/ej2-react-layouts';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { ButtonComponent, CheckBoxComponent, RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { DropDownListComponent, MultiSelectComponent, ComboBoxComponent, CheckBoxSelection, Inject, AutoCompleteComponent } from '@syncfusion/ej2-react-dropdowns';

import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { format, parseISO } from 'date-fns';

import { useSearchParams, useNavigate, Link } from 'react-router-dom';

import { DataManager, Query } from '@syncfusion/ej2-data';
import axios from 'axios';
import compliance from '../data/compliance-2.png';
import scribeHow from '../data/scribehow.png';
import { useStateContext } from '../contexts/ContextProvider';
import { Header, PredictorAI, Events, Configuration, DevLog, SSTEvents, DuressEvents, GMap, Heartbeat, AssociateCal } from '../components';
import orgpng from '../data/organization.png';
import lngpng from '../data/language.png';
import './Zackat.css';
import profile from '../data/profile.png';

const MobileAssociateLayout = () => {
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  const navigate = useNavigate();
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const {
    screenSize,
    setScreenSize,
    setPatientId,
    isClicked,
    patientid,
    notificationDevice,
    isMobile,
  } = useStateContext();

  const [enableDetails, setDetails] = useState(true);
  const [enableEvents, setEvents] = useState(true);
  const [crudUpdate, setCrudUpdate] = useState(false);
  const [crudCreate, setCrudCreate] = useState(false);
  const [crudDelete, setCrudDelete] = useState(false);
  const [inviteEnable, setInviteEnable] = useState(false);
  const [scheduleEnable, setScheduleEnable] = useState(false);
  const [sttEnable, setSttEnable] = useState(false);
  const [duressEnable, setDuressEnable] = useState(false);
  const [recordings, setRecordingsEnable] = useState(false);
  const [configEnable, setConfigEnable] = useState(false);
  const [devlogEnable, setDevlogEnable] = useState(false);
  const [locationEnable, setLocationEnable] = useState(false);
  const [smsEnable, setSMSEnable] = useState(false);
  const [chartsEnable, setChartsEnable] = useState(false);
  const [associateid, setAssociateId] = useState('');
  const [limit, setLimit] = useState(0);
  const [groupLazy, setGroupLazy] = useState(true);
  const [searchParams] = useSearchParams();
  const [currentAssociate, setCurrentAssoicate] = useState(localStorage.getItem('currentAssociate'));
  const { REACT_APP_API_ENDPOINT } = process.env;
  const [riskColor, setRiskColor] = useState('e-outline');
  const [envColor, setEnvColor] = useState('e-outline');
  const [duressColor, setDuressColor] = useState('transparent');
  const [hypoColor, setHypoColor] = useState('transparent');
  const [baseColor, setBaseColor] = useState('transparent');
  const [moderateColor, setModerateColor] = useState('transparent');
  const [elevatedColor, setElevatedColor] = useState('transparent');
  const [severeColor, setSevereColor] = useState('transparent');
  const [selName, setName] = useState(currentAssociate);
  const [selVitals, setVitals] = useState('');
  const [selDevice, setDevice] = useState('');
  const [selOrganization, setOrganization] = useState('');
  const [selLanguage, setLanguage] = useState('');
  const [selEngineering, setEngineering] = useState(false);
  const [selEmployeeImage, setEmployeeImage] = useState('');
  const [selMobile, setMobile] = useState('');
  const [selEmail, setEmail] = useState('');
  const [selReportsTo, setReportsTo] = useState('');
  const [associate, setAssociate] = useState(null);
  const [selRisk, setRisk] = useState('');
  const [selEnvironment, setEnvironment] = useState('');
  const [selAddress, setAddress] = useState('');
  const [selAddress1, setAddress1] = useState('');
  const [selCity, setCity] = useState('');
  const [selState, setState] = useState('');
  const [selZip, setZip] = useState('');
  const [selDob, setDob] = useState('');
  const [selAge, setAge] = useState('');
  const [selLat, setLat] = useState('');
  const [selLng, setLng] = useState('');
  const [smsOptin, setSMSOptin] = useState(false);
  const [emailOptin, setEmailOptin] = useState('');
  const [gender, setGender] = useState('');
  const [selTemperature, setTemperature] = useState('');
  const [selTemperatureBaseline, setTemperatureBaseline] = useState('');
  const [selHeartrate, setHeartrate] = useState('');
  const [selHeartrateBaseline, setHeartrateBaseline] = useState('');
  const [selOxygen, setOxygen] = useState('');
  const [selOxygenBaseline, setOxygenBaseline] = useState('');
  const [dataChanged, setDataChanged] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mgrData, setMgrData] = useState([]);
  const [taskData, setJobTasks] = useState([]);
  const [selJobTask, setJobTask] = useState('');
  const [managers, setManagers] = useState([]);
  const [selRefresh, setRefresh] = useState('');
  const [bundleData, setBundleData] = useState([]);
  const [selBundle, setBundle] = useState([]);
  const [timezone, setTimezone] = useState('');

  const actionData = [
    { text: 'Not specified', value: 'na' },
    { text: 'Check In', value: '"checkin":"query"' },
    { text: 'Development', value: '"srvr":{"url":"biometric.zackat.com", "port": "10900"}' },
    { text: 'FOTA', value: '"fota":"ind"' },
    { text: 'Locate', value: '"locate":"query"' },
    { text: 'Production', value: 'srvr":{"url":"bio.zackatlabs.com", "port": "10900"}' },
    { text: 'Restart', value: '"reset":"restart"' },
    { text: 'Sleep', value: '"reset":"sleep"' },
    { text: 'SMS', value: '""' },
    { text: 'Staging', value: '"srvr":{"url":"biometric.zackatlabs.com", "port": "10900"}' },
  ];
  const [actions, setActions] = useState(actionData);
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    try {
      // Core Clipboard API call
      await navigator.clipboard.writeText(e);
      setCopied(true);

      // Reset the status message after 2 seconds
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };
  const { amapActive,
    setAmapActive,
    boss,
    handleClick,
    setAIType,
  } = useStateContext();
  const dashboardObj = useRef(null);
  const cellSpacing = [5, 5];
  const count = 8;
  const onCloseIconHandler = (event) => {
    const panel = event.target;
    if (panel.offsetParent) {
      dashboardObj.current.removePanel(panel.offsetParent.id);
    }
  };
  const savebuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        saveProfile();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'SAVE',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  const [sstEventDialog, setSSTEventDialog] = useState(true);
  const [duressEventDialog, setDuressEventDialog] = useState(true);
  const [devlogDialog, setDevlogDialog] = useState(true);
  const [gmapDialog, setGMapDialog] = useState(true);
  const [chartsDialog, setChartsDialog] = useState(true);
  const [calDialog, setCalDialog] = useState(true);
  const [cfgDialog, setCfgDialog] = useState(true);
  const associateTimer = useRef(null);
  // let localduressColor = 'transparent';
  let localtimestamp = null;
  const toggleFetchAssociate = async () => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = limit;
    // fetch data
    const query = Object.entries(usr)
      .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
      .join('&');
    const url = `${REACT_APP_API_ENDPOINT}/associates?associate=${currentAssociate}&${query}&limit=1`;
    const mydata = await (
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
    ).json();
    if (mydata && mydata.associates && mydata.associates.length > 0) {
      if (mydata.associates[0].bp && mydata.associates[0].bp === 'duress' /* && localduressColor !== 'red' */) {
        setDuressColor('red');
        // localduressColor = 'red';
        // console.log('associateFetch RED', mydata.associates[0].bp);
      } else if (mydata.associates[0].bp && mydata.associates[0].bp !== 'duress' /* && localduressColor === 'red' */) {
        setDuressColor('transparent');
        // localduressColor = 'transparent';
        // console.log('associateFetch XPT', mydata.associates[0].bp);
      }
      if (localtimestamp !== mydata.associates[0].timestamp) {
        // if the timestamp changed then we should refetch date
        // indicator tothe ui to let me know it is about to change
        setDuressColor('lightgrey');
        // update our local timestamp
        localtimestamp = mydata.associates[0].timestamp;
      }
    }
    // console.log('associatefetch', mydata.associates[0].bp, localduressColor);
  };
  useEffect(() => {
    let browserTimezone = 'UTC';
    try {
      browserTimezone = Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
        .formatToParts(new Date())
        .find((part) => part.type === 'timeZoneName')
        .value;
    } catch (error) {
      // Fallback if formatting fails
      console.error('browser timezone', error);
    }

    // console.log('what is the browser timezone', browserTimezone);
    setTimezone(browserTimezone);
    associateTimer.current = setInterval(toggleFetchAssociate, 10000);
    return () => {
      associateTimer.current = clearInterval(associateTimer.current);
    };
  }, []);
  useEffect(() => {
    setCurrentAssoicate(notificationDevice);
  }, [notificationDevice]);

  const memoizedData = useMemo(() => associate, [associate]);

  useEffect(() => {
  }, [memoizedData]);
  // 2. Wrap the template function in useCallback
  const cfgTemplate = useCallback(() => {
    if (memoizedData && memoizedData.name) {
      return <Configuration dt={memoizedData} />;
    }
    return null; // Always return null or fallback UI if data isn't ready
  }, [memoizedData]); // Only changes if memoizedData changes
  const sstEventTemplate = () => (
    <SSTEvents props={associate} />
  );
  const duressEventTemplate = () => (
    <DuressEvents props={associate} />
  );
  const devlogTemplate = () => (
    <DevLog props={associate} />
  );
  const gmapTemplate = () => (
    <GMap props={associate} />
  );
  const chartTemplate = () => (
    <Heartbeat props={associate} />
  );
  const calTemplate = () => (
    <AssociateCal props={associate} />
  );

  const handleSSTEventDialogClick = () => {
    setSSTEventDialog(!sstEventDialog);
  };
  const handleDuressEventDialogClick = () => {
    setDuressEventDialog(!duressEventDialog);
  };
  const handleCfgDialogClick = () => {
    setCollapseConfiguration(false);
    setCfgDialog(true);
  };
  const handleGMapDialogClick = () => {
    setGMapDialog(!gmapDialog);
  };
  const handleChartsDialogClick = () => {
    setChartsDialog(!chartsDialog);
  };
  const gmapbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleGMapDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];

  const cfgbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleCfgDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },

  ];
  const ssteventsbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleSSTEventDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const duresseventsbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDuressEventDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const chartbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleChartsDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  const calbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setCalDialog(true);
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];

  const addbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        addProfile();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'ADD',
      },
    },
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        setDuressColor('white');
        handleDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'CANCEL',
      },
    },
  ];
  const handleDevLogDialogClick = () => {
    setDevlogDialog(!devlogDialog);
  };

  const devlogbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDevLogDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];

  const header = () => (
    <div><h1>{associateid === 'add_associate' ? 'Add' : 'Edit'} Associate {selName}</h1></div>
  );
  const profileTemplate = () => (
    <div className="bg-white rounded-3xl">
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-2">
        <div className="e-input-group">
          <TextBoxComponent
            placeholder="Name"
            title="Associate Name"
            value={selName}
            cssClass="e-error e-outline"
            floatLabelType="Auto"
            onChange={(v) => { setName(v.value); }}
          />
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
          <div className="e-input-group">
            <MultiSelectComponent id="ddlreport" dataSource={mgrData} fields={{ value: '_id', text: 'name' }} cssClass="e-outline" disabled={associateid === 'add_associate'} floatLabelType="Auto" mode="CheckBox" value={managers} onChange={saveManagers} placeholder="Select Manager">
              <Inject services={[CheckBoxSelection]} />
            </MultiSelectComponent>
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
          <div className="e-input-group">
            <DropDownListComponent id="ddljob" cssClass="e-outline" floatLabelType="Auto" dataSource={taskData} fields={{ value: 'id', text: 'text' }} placeholder="Select Task" value={selJobTask} onChange={(v) => { setJobTask(v.value); }} />
          </div>
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Enter Address" value={selAddress} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAddress(v.value); }} />
        </div>
        <div className="e-input-group">
          <TextBoxComponent placeholder="Enter Address cont." value={selAddress1} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAddress1(v.value); }} />
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Enter City" value={selCity} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setCity(v.value); }} />
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Enter State" value={selState} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setState(v.value); }} />
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Enter ZipCode" value={selZip} showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setZip(v.value); }} />
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Mobile" value={selMobile} type="text" showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setMobile(v.value); }} />
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Email Address" value={selEmail} type="email" showClearButton cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setEmail(v.value); }} />
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent placeholder="Device" width={250} title="SIM Device Identification" showClearButton value={selDevice} type="text" cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setDevice(v.value); }} />
        </div>
      </div>

      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6 mb-4">
        <div className="e-input-group">
          <CheckBoxComponent label="SMS OpIin" title="Controlled via mobile App" disabled checked={smsOptin} />
          <CheckBoxComponent label="Email OptIn" title="Controlled via mobile App" disabled checked={emailOptin} />
          {boss && <CheckBoxComponent label="Engineering Use Only" checked={selEngineering} change={(v) => { setEngineering(v.checked); }} />}
        </div>
      </div>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6 mb-4">
        <div className="e-input-group">
          {boss && <TextBoxComponent placeholder="Refresh Rate" floatLabelType="Auto" width={150} title="Refresh Rate" showClearButton value={selRefresh} type="text" cssClass="e-outline" onChange={(v) => { setRefresh(v.value); }} />}
        </div>
      </div>
      <div className="row custom-margin">
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 mt-6">
          <div className="e-input-group">
            <DatePickerComponent id="dob" cssClass="e-outline" floatLabelType="Auto" change={setDateOfBirth} onChange={setDateOfBirth} placeholder="Date of Birth M/D/YYYY" value={selDob} />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6 mb-4">
          <div className="e-input-group">
            <TextBoxComponent placeholder="Age" width={100} title="Calculated from Date of Birth" value={selAge} type="text" disabled cssClass="e-outline" floatLabelType="Auto" onChange={(v) => { setAge(v.value); }} />
            <div className="row">
              <RadioButtonComponent label="Male" name="gender" value="male" checked={gender === 'male'} onChange={(v) => { setGender(v.value); }} />
            </div>
            <div className="row">
              <RadioButtonComponent label="Female" name="gender" value="female" checked={gender === 'female'} onChange={(v) => { setGender(v.value); }} />
            </div>
          </div>
        </div>
      </div>
      <div className="row custom-margin">
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
          <div className="e-input-group mt-6">
            <DropDownListComponent id="ddlelement" floatLabelType="Auto" cssClass="e-outline" dataSource={organizations.params.dataSource} fields={organizations.params.fields} placeholder="Select Organization" value={selOrganization} onChange={(v) => { setOrganization(v.value); }} />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
          <div className="e-input-group mt-6">
            <DropDownListComponent id="ddllanguage" floatLabelType="Auto" cssClass="e-outline" dataSource={langParams.params.dataSource} fields={langParams.params.fields} placeholder="Select Language" value={selLanguage} onChange={(v) => { setLanguage(v.value); }} />
          </div>
        </div>
        <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6">
          <div className="e-input-group mt-6">
            <DropDownListComponent id="ddlbundle" floatLabelType="Auto" cssClass="e-outline" dataSource={bundles.params.dataSource} fields={bundles.params.fields} placeholder="Select AlertBundle" value={selBundle} onChange={(v) => { setBundle(v.value); }} />
          </div>
        </div>
      </div>
    </div>
  );
  const panel1Content = () => (
    <div className="e-panel-container zackat-divalh" style={{ backgroundColor: duressColor, padding: '12px', overflowY: 'auto' }}>
      <span style={{ display: 'block', textAlign: 'center' }}>Associate</span>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group">
          <TextBoxComponent
            placeholder="Name"
            title="Associate Name (read only)"
            value={associate.name || ''}
            cssClass="e-success e-outline"
            floatLabelType="Auto"
            onChange={(v) => { associate.name = v.value; }}
            readOnly
          />
        </div>
        {duressColor === 'red' && (
        <div className="mt-6 mb-2 flash-animation" style={{ backgroundColor: 'white', textAlign: 'center', fontSize: '1.5rem' }}>
          DURESS
        </div>
        )}
        <div className="e-input-group mt-4 flex">
          <TextBoxComponent
            placeholder="DOB"
            title="DOB"
            value={associate.dob || ''}
            cssClass="e-success e-outline"
            floatLabelType="Auto"
            onChange={(v) => { associate.dob = v.value; setDob(v.value); }}
            readOnly
          />
          <TextBoxComponent
            placeholder={gender === 'm' || gender === 'male' ? 'Male Age' : gender === 'f' || gender === 'female' ? 'Female Age' : '- Age'}
            title="Age"
            defaultValue={selAge || ''}
            cssClass="e-success e-outline"
            floatLabelType="Auto"
            disabled
          />
        </div>
        <div className="e-input-group mt-4 flex">
          <TextBoxComponent
            placeholder="Organization"
            title="Organization"
            value={associate.organization || ''}
            cssClass="e-success e-outline"
            floatLabelType="Auto"
            readOnly
          />
          <AutoCompleteComponent
            id="langLookup"
            dataSource={langData}
            fields={fieldsConfig}
            cssClass="e-success e-outline"
            placeholder="Language"
            floatLabelType="Auto"
            value={associate.language}
            readOnly
          />
        </div>
        <div
          style={{ display: 'flex', gap: '20px', position: 'relative', zIndex: '2' }}
          className="mt-4"
        >
          {associate && associate._id && associate._id.length > 0 && (
            <><ButtonComponent id="edit" cssClass="e-icons e-edit" disabled={!crudUpdate} onClick={handleDialogClick}>Edit</ButtonComponent>
              <ButtonComponent id="delete" cssClass="e-icons e-trash" disabled={!crudDelete} onClick={deleteProfile}>Delete</ButtonComponent>
            </>
          )}
          <div className="absolute right-0 mr-4">
            <ButtonComponent id="add" cssClass="e-icons e-plus" disabled={!crudCreate} onClick={handleNewClick}>New</ButtonComponent>
          </div>
        </div>
      </div>
    </div>
  );
  const panel2Content = () => (
    <div className="e-panel-container zackat-divalh max-w-full" style={{ overflowY: 'auto' }}>
      <span style={{ display: 'block', textAlign: 'center' }}> BIOMETRICS</span>
      <table
        className="biotable1 max-w-full w-full"
      >
        <tbody>
          <tr width="100%">
            <th style={{ backgroundColor: hypoColor, padding: '0.5rem', width: '20%', textAlign: 'center' }}>
              <font color="blue">HYPO</font>
            </th>
            <th style={{ backgroundColor: baseColor, width: '20%', padding: '0.5rem', textAlign: 'center' }}>
              <font color="green">BASELINE</font>
            </th>
            <th style={{ backgroundColor: moderateColor, width: '20%', padding: '0.5rem', textAlign: 'center' }}>
              <font color="yellow">MODERATE</font>
            </th>
            <th style={{ backgroundColor: elevatedColor, width: '20%', padding: '0.5rem', textAlign: 'center' }}>
              <font color="orange">ELEVATED</font>
            </th>
            <th style={{ backgroundColor: severeColor, width: '20%', padding: '0.5rem', textAlign: 'center' }}>
              <font color="red">SEVERE</font>
            </th>
          </tr>
        </tbody>
      </table>
      <table className="biotable1 w-full">
        <tbody>
          <tr>
            <th colSpan={2} style={{ backgroundColor: 'white' }}>Risk Level {associate.risk}</th>
          </tr>
          <tr>
            <td className={associate.heartrate && associate.heartrate.alert && associate.heartrate.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsgrn'}>
              <sup className="supsm">hr</sup>
              💖{associate.heartrate && associate.heartrate.reading ? associate.heartrate.reading : ''}
              <sub className="supsm">bpm</sub>
              <sup className="supsm">
                ({associate.baseline && associate.baseline.heartrate && associate.baseline.heartrate.nominal ? associate.baseline.heartrate.nominal.toFixed(1) : ''})
              </sup>
            </td>
            <td className={associate.hrv && associate.hrv.alert && associate.hrv.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsltgrn'}>
              <sup className="supsm">hrv</sup>
              💗{associate.hrv && associate.hrv.reading ? associate.hrv.reading : ''}
              <sub className="supsm">ms</sub>
              <sup className="supsm">
                ({associate.baseline && associate.baseline.hrv && associate.baseline.hrv.nominal ? associate.baseline.hrv.nominal.toFixed(1) : ''})
              </sup>
            </td>
          </tr>
          <tr>
            <td className={associate.oxygen && associate.oxygen.alert && associate.oxygen.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsorn'}>
              <sup className="supsm">oxy</sup>
              <span className="biometricsltblue">O<sub>2</sub></span>
              {associate.oxygen && associate.oxygen.reading ? associate.oxygen.reading : ''}
              <sub className="supsm">%</sub>
              <sup className="supsm">
                ({associate.baseline && associate.baseline.oxygen && associate.baseline.oxygen.nominal ? associate.baseline.oxygen.nominal.toFixed(1) : ''})
              </sup>
            </td>
            <td className={associate.temperature && associate.temperature.alert && associate.temperature.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsylw'}>
              <sup className="supsm">temp</sup>
              <span className="rotate-char">🌡</span>{associate.temperature && associate.temperature.reading ? associate.temperature.reading : ''}
              <sub className="supsm">°F</sub>
              <sup className="supsm">
                ({associate.baseline && associate.baseline.temperature && associate.baseline.temperature.nominal ? associate.baseline.temperature.nominal.toFixed(1) : ''})
              </sup>
            </td>
          </tr>
          <tr>
            <td className={associate.hydration && associate.hydration.alert && associate.hydration.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsblue'}>
              <sup className="supsm">hyd</sup>
              💦{associate.hydration && associate.hydration.reading ? associate.hydration.reading : ''}
              <sub className="supsm">%</sub>
              <sup className="supsm">
                ({associate.baseline && associate.baseline.hydration && associate.baseline.hydration.nominal ? associate.baseline.hydration.nominal.toFixed(1) : ''})
              </sup>
            </td>
            <td className={associate.respiratory && associate.respiratory.alert && associate.respiratory.alert.length > 0 ? 'biometricsred flash-animation' : 'biometricsblue'}>
              <sup className="supsm">rr</sup>
              🫁{associate.respiratory && associate.respiratory.reading ? associate.respiratory.reading : ''}<sub className="supsm">b/m</sub>
              <sup className="supsm">
                ({associate.baseline && associate.baseline.respiratory && associate.baseline.respiratory.nominal ? associate.baseline.respiratory.nominal.toFixed(1) : ''})
              </sup>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
  const panel3Content = () => (
    <div className="e-panel-container zackat-divalh">
      <span style={{ display: 'block', textAlign: 'center' }}>Events</span>
      <div className="e-panel-container">
        <div className="text-align"><Events props={associate} /></div>
      </div>
    </div>
  );
  const panel4Content = () => (
    <div className="e-panel-container zackat-divalh" style={{ overflowY: 'auto' }}>
      <span style={{ display: 'block', textAlign: 'center' }}>Inventory</span>
      <div className="col-xs-6 col-sm-6 col-lg-6 col-md-6 m-2 mt-6">
        <div className="e-input-group mt-4">
          <TextBoxComponent
            placeholder="Device"
            title="Device"
            value={associate.device || ''}
            cssClass="e-success e-outline"
            floatLabelType="Auto"
            onChange={(v) => { associate.device = v.value; }}
          />
        </div>
        <div className="e-input-group mt-4">
          <TextBoxComponent
            placeholder="MSN"
            title="MSN"
            value={associate.resultField && associate.resultField.length === 1 && associate.resultField[0].msn ? associate.resultField[0].msn : ''}
            cssClass="e-success e-outline"
            floatLabelType="Auto"
            readOnly
          />
        </div>
        {associate.resultField && associate.resultField[0] && (
          <div>
            <div className="e-input-group">
              IMEI: {associate.resultField && associate.resultField.length === 1 && associate.resultField[0].imei ? associate.resultField[0].imei : ''}
              <ButtonComponent
                id="copyimei"
                cssClass="e-icons e-small e-copy e-xp e-flat"
                disabled={!associate.resultField[0].imei}
                onClick={(e) => { handleCopy(associate.resultField[0].imei); }}
              />
              &nbsp;&nbsp;SKU: {associate.resultField && associate.resultField.length === 1 && associate.resultField[0].sku ? associate.resultField[0].sku : ''}
              <ButtonComponent
                id="copymsn"
                cssClass="e-icons e-small e-copy e-xp e-flat"
                disabled={!associate.resultField[0].msn}
                onClick={(e) => { handleCopy(associate.resultField[0].msn); }}
              />
            </div>
            <div className="e-input-group" title="IMEI: International Mobile Equipment Identity&#013;&#010;RRSP: Reference Signal Received Power&#013;&#010;SKU: Stock Keeping Unit&#013;&#010;SIM: Subscriber Identity Module">
              Version: {associate.resultField && associate.resultField.length === 1 && associate.resultField[0].version ? associate.resultField[0].version : ''}
      &nbsp;&nbsp;Battery: {associate.resultField && associate.resultField.length === 1 && associate.resultField[0].battery ? associate.resultField[0].battery : ''}%
      &nbsp;&nbsp;RRSP: {associate.resultField && associate.resultField.length === 1 && associate.resultField[0].rssi ? associate.resultField[0].rssi : ''}
            </div>
            <div className="e-input-group">
              Compliance: {associate.resultField && associate.resultField.length === 1 && associate.resultField[0].skinContact && associate.resultField[0].skinContact === 1 ? <img src={compliance} width={30} /> : 'OFF'}
      &nbsp;&nbsp;Charger: {associate.resultField && associate.resultField.length === 1 && associate.resultField[0].charger && associate.resultField[0].charger === 'off' ? 'OFF' : associate.resultField[0].charger.toUpperCase()}
            </div>
            <div className="e-input-group">
              SIM: {associate.resultField && associate.resultField.length === 1 && associate.resultField[0].simstatus && associate.resultField[0].simstatus.status ? associate.resultField[0].simstatus.status : ''}
          &nbsp;&nbsp;TZ: {associate.resultField && associate.resultField.length === 1 && associate.resultField[0].tzoffset ? (Number(associate.resultField[0].tzoffset) / 4) : ''}
            </div>
            <div className="e-input-group">
              Last Reported: {associate.resultField && associate.resultField.length === 1 && associate.resultField[0].timestamp ? `${format(parseISO(associate.resultField[0].timestamp), 'MM-dd-yy p')} ${timezone}` : ''}
            </div>
          </div>
        )}
      </div>
    </div>
  );
  const panel5Content = () => (
    <div className="e-panel-container zackat-divalh" style={{ overflowY: 'auto' }}>
      <span style={{ display: 'block', textAlign: 'center' }}>Location</span>
      <GMap props={associate} />
    </div>
  );
  const multilineAttributes = {
    rows: 4, // Sets the initial visible number of lines to 4
  };

  const searchThis = () => {
    const search = document.getElementById('associatesearch');
    if (search && search.value && search.value.length > 0) {
      // setName(search.value);
      // Use Effect localStorage.setItem('currentAssociate', search.value);
      setCurrentAssoicate(search.value);
      // setReload(!reload);
    }
  };
  const handleKeyDown = (e) => {
    // Check if the pressed key is "Enter"
    if (e.key === 'Enter') {
      // Prevent the default form submission behavior
      e.preventDefault();
      // Perform your search or submission logic here
      searchThis(e);
      // Optional: Clear the textbox after searching
      // setValue('');
    }
  };
  const bundles = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(bundleData),
      fields: { value: '_id', text: 'name' },
      query: new Query(),
    },
  };
  const addProfile = () => {
    const result = orgData.find(({ id }) => id === selOrganization);
    const newassociate = {};
    newassociate.organizationid = selOrganization;
    newassociate.organization = result.value;
    const lresult = langData.find(({ id }) => id === selLanguage);
    newassociate.language = lresult.id;
    newassociate.name = selName;
    newassociate.device = selDevice;
    newassociate.mobile = selMobile;
    newassociate.email = selEmail;
    newassociate.address = selAddress;
    newassociate.address1 = selAddress1;
    newassociate.city = selCity;
    newassociate.state = selState;
    newassociate.zip = selZip;
    newassociate.jobtask = selJobTask;
    newassociate.alertBundle = selBundle;
    newassociate.engineering = selEngineering;
    newassociate.refresh = selRefresh.toString();
    newassociate.employeeImage = 'https://monaco.zackat.com/blank.png';
    if (selDob !== '') {
      newassociate.dob = new Date(selDob).toLocaleDateString();
    } else {
      newassociate.dob = '';
    }
    if (gender === 'male') {
      newassociate.gender = 'male';
    } else if (gender === 'female') {
      newassociate.gender = 'female';
    } else {
      newassociate.gender = '';
    }
    fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(newassociate),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        if (responseJson && responseJson._id) {
          newassociate._id = responseJson._id;
          setAssociateId(newassociate._id);
          setPatientId(newassociate._id);
        }
        if (responseJson && responseJson.response && responseJson.response !== 'OK') {
          DialogUtility.alert(responseJson.response);
        } else {
          setCurrentAssoicate(selName);
          setDialog(!hideDialog);
        }
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during New Associate Insert!');
      });
  };
  const cancelProfile = () => {
    setAssociateId('');
    setOrganization('');
    setLanguage('');
  };
  let dialogInstance;
  const deleteProfileNow = () => {
    const aryAssociates = [];
    aryAssociates.push(associate);
    fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(aryAssociates),
    })
      .then((response) => response.json())
      .then((responseJson) => {
      // The added/edited data will be saved in the Grid
      // The default edit operation is cancelled
        setCurrentAssoicate('--DELETED--');
        if (responseJson.response !== 'OK') {
          DialogUtility.alert(`Delete ${selName} ${responseJson.response}`);
        }
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during Delete!');
      });
  };

  const deleteProfile = () => {
    dialogInstance = DialogUtility.confirm({
      title: 'Confirmation Required',
      content: `Are you sure you want to Delete this Associate for ${associate.name}?`,
      okButton: { text: 'OK', click: () => { dialogInstance.hide(); deleteProfileNow(); } },
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
    });
  };
  const saveProfile = (e) => {
    if (selOrganization && associate.organizationid !== selOrganization) {
      const result = orgData.find(({ id }) => id === selOrganization);
      if (!confirm(`Would you like to move this Associate ${associate.name} from ${associate.organization} to ${result.value}`)) {
        return;
      }
      associate.organizationid = selOrganization;
      associate.organization = result.value;
    }
    if (selLanguage && associate.language !== selLanguage) {
      const result = langData.find(({ id }) => id === selLanguage);
      associate.language = result.id;
    }
    associate.jobtask = selJobTask;
    associate.managers = managers;

    if (selName.length === 0) {
      DialogUtility.alert('Please provide a name for the associate');
      return;
    }
    if (selDevice.length > 0 && (selDevice.length < 19 || selDevice.length > 20)) {
      DialogUtility.alert('Please provide a valid device for the associate');
      return;
    }
    if (selEmail.length > 0 && !selEmail.includes('@') && !selEmail.includes('.')) {
      DialogUtility.alert('Please provide a valid email for the associate');
      return;
    }

    associate.name = selName;
    associate.device = selDevice;
    associate.mobile = selMobile;
    associate.email = selEmail;
    associate.address = selAddress;
    associate.address1 = selAddress1;
    associate.city = selCity;
    associate.state = selState;
    associate.zip = selZip;
    associate.engineering = selEngineering;
    if (selDob && selDob.length > 0 && selDob !== 'Invalid Date' && selDob !== 'undefined') {
      associate.dob = new Date(selDob).toLocaleDateString();
    } else {
      associate.dob = '';
    }
    if (gender === 'male') {
      associate.gender = 'male';
    } else if (gender === 'female') {
      associate.gender = 'female';
    }
    associate.alertBundle = selBundle;
    fetch(`${REACT_APP_API_ENDPOINT}/associates`, {
      method: 'UPDATE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(associate),
    })
      .then((response) => response.json())
      .then(() => {
        // The added/edited data will be saved in the Grid
        // The default edit operation is cancelled
        DialogUtility.alert('Profile saved');
        setDuressColor('white');
        setDialog(true);
      })
      .catch((error) => {
        console.error(error);
        DialogUtility.alert('An error has occured during Update!');
      });
  };

  const onToolbarChange = (args) => {
    if (!associate || !associate._id || associate._id.length === 0) {
      return;
    }

    if (args.target.textContent === 'Raw Events') {
      navigate(`../events?id=${associate._id}&name=${associate.name}`);
    }
    if (args.target.textContent === 'Location' && selLat !== '' && selLng !== '') {
      // navigate(`../basic?id=${associate._id}&lat=${selLat}&lng=${selLng}&name=${associate.name}&tabNo=1`);
      setGMapDialog(!gmapDialog);
    }
    if (args.target.textContent === 'Invite') {
      inviteSomeone();
    }
    if (args.target.textContent === 'Schedule') {
      // navigate(`/basic?id=${associate._id}&lat=${associate.latlng.latitude}&lng=${associate.latlng.longitude}&name=${associate.name}&tabNo=3`);
      setCalDialog(!calDialog);
    }
    if (args.target.textContent === 'Duress') {
      setDuressEventDialog(!duressEventDialog);
    }
    if (args.target.textContent === 'Devlog') {
      setDevlogDialog(!devlogDialog);
    }
    if (args.target.textContent === 'Configuration') {
      setCfgDialog(false);
    }
    if (args.target.textContent === 'Charts') {
      setChartsDialog(!chartsDialog);
    }
    if (args.target.textContent === 'Alerts') {
      dialogInstance = DialogUtility.confirm({
        title: 'Ack Alerts/Notifications',
        content: `Acknowledge all Alerts and Notifications for ${associate.name}?`,
        okButton: { text: 'OK',
          click: () => {
            dialogInstance.hide();
            const updateAssociate = async () => {
              associate.activity.alert = '';
              associate.oxygen.alert = '';
              associate.heartrate.alert = '';
              associate.hrv.alert = '';
              associate.temperature.alert = '';
              associate.hydration.alert = '';
              associate.bloodpressure.alert = '';
              const newData = associate;
              axios.defaults.headers.common.Authorization = `JWTToken ${usr.token}`;
              axios.put(
                `${REACT_APP_API_ENDPOINT}/associates?ack=true`,
                newData,
              ).then((response) => {
              // Handle the response
              // window.location.reload();
                dialogClick('na', 'Alerts', `acknowledged ${response.data.response}`, null);
                setReload(!reload);
              // data.associates = selectedRecords;
              })
                .catch((error) => {
                // Handle errors
                  dialogClick('na', 'Alerts', `error ${error.message}`, null);
                });
            };
            updateAssociate();
          } },
        cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
        showCloseIcon: true,
        closeOnEscape: true,
        isModal: true,
        animationSettings: { effect: 'Zoom' },
      });
    }
    if (args.target.textContent === 'AI') {
      setAIType('Predictive Analysis');
      handleClick('userFaq');
    }
  };
  const [selectedOption, setSelectedOption] = useState('');
  const actionComponent = () => (
    <div>
      <DropDownListComponent id="ddlelement" dataSource={actions} placeholder="Device Action" value={selectedOption} onChange={(e) => { dialogClick('sms', 'Send Device Action', `Would you lke to send this action ${e.target.itemData.text}?`, e); }} />
    </div>
  );

  const audioData = [
    { text: 'Not specified', value: 'na' },
  ];
  const [selectedAudioOption, setSelectedAudioOption] = useState(audioData[0]);
  const audioComponent = () => (
    <div>
      <DropDownListComponent dataSource={audioData} placeholder="Send Recording" value={selectedAudioOption} onChange={(e) => { dialogClick('recording', 'Send Recording', `Would you lke to send this recording ${e.target.itemData.text}?`, e); }} />
    </div>
  );
  const inviteSomeone = () => {
    if (!associate || !associate._id || associate._id.length === 0) {
      return;
    }
    const recipient = prompt('Please enter the email address of the Associate that you would like to receive the invitation!', associate.email);
    if (recipient) {
      fetch(`${REACT_APP_API_ENDPOINT}/invite?associateid=${associate._id}&recipient=${recipient}&email=${usr.email}`, {
        method: 'GET',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson && responseJson.response && responseJson.response !== 'OK') {
            dialogClick('na', 'Invite handler', responseJson.response, null);
          }
        })
        .catch((error) => {
          dialogClick('na', 'Invite handler', 'An error has occured during Invitation request!', null);
        });
    }
  };
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const bundleFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/alerts?${query}`;
      try {
        const mydata = await (
          await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `JWTToken ${usr.token}`,
            },
          })
        ).json();
        // set state when the data received
        const mybundles = [{ _id: '', name: 'N/A' }];
        if (mydata && mydata.alerts) {
          const selectedArray = mydata.alerts.map((alert) => ({
            _id: alert._id,
            name: alert.name,
          }));
          mybundles.push(...selectedArray);
        }
        setBundleData(mybundles);
      } catch (error) {
        console.error(error);
      }
    };
    bundleFetch();
  }, []);
  const saveManagers = (e) => {
    setManagers(e.value);
  };

  useEffect(() => {
    if (associate && associate.organizationid && associate.organizationid.length > 0) {
      usr.organizationid = associate.organizationid;
      usr.organization = associate.organization;
    }
    const getJobsData = async () => {
      if (!associate || !associate.organizationid) {
        return;
      }
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/organizations?${query}&orgid=${associate.organizationid}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          let myjobs = [];
          if (mydata && mydata.tasks && mydata.tasks.length > 0) {
            myjobs = mydata.tasks;
          }
          setJobTasks(myjobs);
        })
        .catch((error) => {
          setJobTasks([]);
        });
    };
    getJobsData();
  }, [selName]);
  useEffect(() => {
    const getManagerData = async () => {
      if (!associate || !associate.organizationid) {
        return;
      }

      if (associate && associate.organizationid && associate.organizationid.length > 0) {
        usr.organizationid = associate.organizationid;
      }
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/managers?${query}&orgid=${associate.organizationid}`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          let mymgr = [];
          if (mydata && mydata.length > 0) {
            mydata.forEach((m) => {
              m.name = `${m.first} ${m.last}`;
            });
            mymgr = mydata;
          }
          setMgrData(mymgr);
        })
        .catch((error) => {
          setMgrData([]);
        });
    };
    getManagerData();
  }, [selOrganization]);
  useEffect(() => {
    if (data.role && data.role.associates) {
      if (data.role.associates.permissions.includes('Create')) {
        setCrudCreate(true);
      } else {
        setCrudCreate(false);
      }
      if (data.role.associates.permissions.includes('Update')) {
        setCrudUpdate(true);
      } else {
        setCrudUpdate(false);
      }
      if (data.role.associates.permissions.includes('Delete')) {
        setCrudDelete(true);
      } else {
        setCrudDelete(false);
      }
      if (data.role.associates.permissions.includes('Invite')) {
        setInviteEnable(true);
      } else {
        setInviteEnable(false);
      }
      if (data.role.associates.permissions.includes('STT')) {
        setSttEnable(true);
      } else {
        setSttEnable(false);
      }
      if (data.role.associates.permissions.includes('Duress')) {
        setDuressEnable(true);
      } else {
        setDuressEnable(false);
      }
      if (data.role.associates.permissions.includes('Recordings')) {
        setRecordingsEnable(true);
      } else {
        setRecordingsEnable(false);
      }
      if (data.role.associates.permissions.includes('SMS')) {
        setSMSEnable(true);
      } else {
        setSMSEnable(false);
      }
      if (data.role.associates.permissions.includes('Location')) {
        setLocationEnable(true);
      } else {
        setLocationEnable(false);
      }
      if (data.role.associates.permissions.includes('Schedule')) {
        setScheduleEnable(true);
      } else {
        setScheduleEnable(false);
      }
      if (data.role.associates.permissions.includes('Devlog')) {
        setDevlogEnable(true);
      } else {
        setDevlogEnable(false);
      }
      if (data.role.associates.permissions.includes('Configuration')) {
        setConfigEnable(true);
      } else {
        setConfigEnable(false);
      }
      if (data.role.associates.permissions.includes('Charts')) {
        setChartsEnable(true);
      } else {
        setChartsEnable(false);
      }
    }
  }, [data]);

  useEffect(() => {
    // 1. Code here runs when the component mounts
    setDuressColor(duressColor);
    return () => {
      // 2. Code here runs when the component unmounts
      setDuressColor('transparent');
    };
  }, []); // Empty dependency array is critical

  const inputStyle = { width: '400px', display: 'inline-block', float: 'right' };
  const [associateData, setAssociateData] = useState([]);
  useEffect(() => {
    usr.organizationid = 'na';
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }

    const associateFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/associates?${query}&abbrev=true&limit=0&mobile=true`;
      await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `JWTToken ${usr.token}`,
        },
      })
        .then((response) => response.json())
        .then((mydata) => {
          // Orig set state when the data received
          if (!mydata.associates) {
            setAssociateData([]);
          } else {
            const myassociates = [];
            mydata.associates.map((item) => (
              myassociates.push({ value: item._id, text: item.name })
            ));
            setAssociateData(myassociates);
          }
        })
        .catch(() => {
        });
    };
    associateFetch();
  }, []);
  // Handles the final selection after filtering
  const onChange = (args) => {
    if (args.itemData) {
      setCurrentAssoicate(args.itemData.text); // Captures Text
    }
  };

  const onFiltering = (args) => {
    let query = new Query();

    // Frame the query based on the typed search string
    if (args.text !== '') {
      // Parameters: Field name, filter type, search string, ignoreCase (bool)
      query = query.where('text', 'contains', args.text, true);
    }
    // Pass the filtered data back to update the dropdown popup UI
    args.updateData(associateData, query);
  };
  const searchComponent = () => (
    <div className="flex mx-auto text-gray-600">
      <ComboBoxComponent
        id="associate-search"
        dataSource={associateData}
        allowFiltering
        filtering={onFiltering}
        value={currentAssociate}
        change={onChange}
        placeholder="Type to search an associate..."
        popupHeight="250px"
      />
      {/*
      <DropDownListComponent
        id="searchable-ddl"
        dataSource={associateData}
        placeholder="Select an Associate"
        allowFiltering
        filterBarPlaceholder="Search..."
        onChange={(e) => { setCurrentAssoicate(e.value); }}
      />
      */}
    </div>
  );
  const fieldsConfig = { text: 'value', value: 'id' };

  const langData = [
    { value: 'English', id: 'en-US' },
    { value: 'German', id: 'de-DE' },
    { value: 'French', id: 'fr-FR' },
    { value: 'French (Canadian)', id: 'fr-CA' },
    { value: 'Spanish (US)', id: 'es-US' },
    { value: 'Spanish', id: 'es-ES' },
    { value: 'Portugese (Brazil)', id: 'pt-BR' },
    { value: 'Portugese (Portugal)', id: 'pt-PT' },
    { value: 'Danish', id: 'da-DK' },
    { value: 'Dutch', id: 'nl-NL' },
    { value: 'Austrailian', id: 'en-AU' },
    { value: 'English (British)', id: 'en-GB' },
    { value: 'English (India)', id: 'en-IN' },
    { value: 'English (Welsh)', id: 'en-GB-WLS' },
    { value: 'Icelandic', id: 'is-IS' },
    { value: 'Italian', id: 'it-IT' },
    { value: 'Japnense', id: 'ja-JP' },
    { value: 'Korean', id: 'ko-KR' },
    { value: 'Norweigan', id: 'nb-NO' },
    { value: 'Polish', id: 'pl-PL' },
    { value: 'Romanian', id: 'ro-RO' },
    { value: 'Russian', id: 'ru-RU' },
    { value: 'Swedish', id: 'sv-SE' },
    { value: 'Turkish', id: 'tr-TR' },
    { value: 'Welsh', id: 'cy-GB' },
    { value: 'Chinese (Simplified)', id: 'zh-CN' },
    { value: 'Chinese (Traditional)', id: 'zh-TW' },
  ];

  const [reload, setReload] = useState([]);
  const [hideDialog, setDialog] = useState(true);
  useEffect(() => {
    // limit associates to the overall selection
    if (!associate) {
      return;
    }
    usr.organizationid = associate.organizationid;
    if (usr && usr.organizationid && usr.organizationid.length === 0 && selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    // fetch data
    const smsFetch = async () => {
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/sms_config?${query}`;
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();

      // set state when the data received
      if (mydata && mydata.sms && mydata.sms.length > 0) {
        const mysms = [];
        mydata.sms.forEach((e) => {
          const s = { text: e.name, value: e.syntax };
          mysms.push(s);
        });
        setActions(mysms);
      }
    };
    smsFetch();
  }, [reload, associate]);
  const handleNewClick = () => {
    setName('');
    setAddress('');
    setCity('');
    setState('');
    setZip('');
    setMobile('');
    setEmail('');
    setEngineering(false);
    setDevice('');
    setRefresh(5);
    setDob('');
    setBundle('');
    setLanguage('en-US');
    setManagers([]);
    setJobTask('');
    setRisk('');
    setEnvironment('');
    setSMSOptin(false);
    setEmailOptin(false);
    setGender('');
    setAge('');
    setAssociateId('add_associate');
    setDialog(!hideDialog);
  };
  const handleDialogClick = () => {
    setAssociateId(associate._id);
    setDialog(!hideDialog);
  };
  const dialogClose = () => {
    setDialog(false);
  };
  const animationSettings = { effect: 'FlipYLeft' };
  const dbuttons = [
    {
      // Click the footer buttons to hide the Dialog
      click: () => {
        handleDialogClick();
      },
      // Accessing button component properties by buttonModel property
      buttonModel: {
        // Enables the primary button
        isPrimary: true,
        content: 'OK',
      },
    },
  ];
  function setDateOfBirth(e) {
    setDob(e.value);
  }
  function rowDataBound(args) {
    /*
    if (args.row) {
      if (getValue('risk', args.data) > 80 || args.data.temperature.reading > 100) {
        args.row.classList.add('rowcellred');
      } else if (getValue('risk', args.data) > 50) {
        args.row.classList.add('rowcellylw');
      } else {
        args.row.classList.add('rowcellgrn');
      }
    }
    */
    args.row.selected = true;
  }
  useEffect(() => {
    const calculateAge = () => {
      if (selDob && selDob !== '') {
        const today = new Date();
        const birthDateObj = new Date(selDob);
        let calculatedAge = today.getFullYear() - birthDateObj.getFullYear();
        const monthDiff = today.getMonth() - birthDateObj.getMonth();

        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
          calculatedAge -= 1;
        }
        setAge(calculatedAge);
      } else {
        setAge('');
      }
    };
    calculateAge();
  }, [selDob]);
  useEffect(() => {
    // limit associates to the overall selection
    if (selectedOrg && selectedOrg.id && selectedOrg.id.length > 0) {
      usr.organizationid = selectedOrg.id;
    }
    usr.limit = limit;
    // fetch data
    const associateFetch = async () => {
      if (!currentAssociate || currentAssociate === '') {
        setLoading(false);
        return;
      }
      const qid = searchParams.get('id');
      if (qid && qid.length > 0) {
        usr.associateid = qid;
      }
      const query = Object.entries(usr)
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
      const url = `${REACT_APP_API_ENDPOINT}/associates?associate=${currentAssociate}&${query}&limit=1`;
      if (!usr.loggedIn) {
        navigate('/login');
        return;
      }
      const mydata = await (
        await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
        })
      ).json();
      if (mydata && mydata.associates && mydata.associates.length > 0) {
        mydata.associates[0].source = 'layout';
        localtimestamp = mydata.associates[0].timestamp;
        if (mydata.associates[0].bp && mydata.associates[0].bp === 'duress') {
          setDuressColor('red');
        } else {
          setDuressColor('transparent');
        }
        setPatientId(mydata.associates[0]._id);
        setRisk(`${mydata.associates[0].risk ? mydata.associates[0].risk : ''}`);
        setEnvironment(`${mydata.associates[0].environment ? mydata.associates[0].environment : ''}`);
        setName(`${mydata.associates[0].name ? mydata.associates[0].name : ''}`);
        setDevice(`${mydata.associates[0].device ? mydata.associates[0].device : ''}`);
        setMobile(`${mydata.associates[0].mobile ? mydata.associates[0].mobile : ''}`);
        setEmail(`${mydata.associates[0].email ? mydata.associates[0].email : ''}`);
        setReportsTo(`${mydata.associates[0].reportsTo ? mydata.associates[0].reportsTo : ''}`);
        setAddress(mydata.associates[0].address ? mydata.associates[0].address : '');
        setAddress1(mydata.associates[0].address1 ? mydata.associates[0].address1 : '');
        setCity(mydata.associates[0].city ? mydata.associates[0].city : '');
        setState(mydata.associates[0].state ? mydata.associates[0].state : '');
        setZip(mydata.associates[0].zip ? mydata.associates[0].zip : '');
        setBundle(mydata.associates[0].alertBundle ? mydata.associates[0].alertBundle : '');
        setRefresh(mydata.associates[0].refresh ? mydata.associates[0].refresh : '');
        setJobTask(mydata.associates[0].jobtask ? mydata.associates[0].jobtask : '');
        setOrganization(mydata.associates[0].organizationid ? mydata.associates[0].organizationid : null);
        if (mydata.associates[0].employeeImage && mydata.associates[0].employeeImage.includes(mydata.associates[0]._id)) {
          const tm = new Date().getTime();
          setEmployeeImage(`${mydata.associates[0].employeeImage}&key=${tm}`);
        } else {
          setEmployeeImage('https://monaco.zackat.com/blank.png');
        }
        if (!mydata.associates[0].language) {
          setLanguage(null);
        } else {
          setLanguage(mydata.associates[0].language);
        }
        setEngineering(mydata.associates[0].engineering);
        setManagers(mydata.associates[0].managers);

        if (mydata.associates[0].dob && mydata.associates[0].dob.length > 0 && mydata.associates[0].dob !== 'Invalid Date'
            && mydata.associates[0].dob !== 'undefined') {
          setDob(mydata.associates[0].dob ? mydata.associates[0].dob : '');
        } else {
          setAge('');
          setDob('');
        }
        setSMSOptin(mydata.associates[0].smsOptin);
        setEmailOptin(mydata.associates[0].emailOptin);
        if (mydata.associates[0].gender && (mydata.associates[0].gender.toLocaleLowerCase() === 'm' || mydata.associates[0].gender.toLocaleLowerCase() === 'male')) {
          setGender('male');
        } else if (mydata.associates[0].gender && (mydata.associates[0].gender.toLocaleLowerCase() === 'f' || mydata.associates[0].gender.toLocaleLowerCase() === 'female')) {
          setGender('female');
        } else {
          setGender('');
        }
        setTemperature(`${mydata.associates[0].temperature && mydata.associates[0].temperature.reading ? `${mydata.associates[0].temperature.reading} °F` : ''}`);
        setTemperatureBaseline(`${mydata.associates[0].baseline && mydata.associates[0].baseline.temperature && mydata.associates[0].baseline.temperature.nominal ? `${mydata.associates[0].baseline.temperature.nominal.toFixed(1)} °F` : ''}`);
        setHeartrate(`${mydata.associates[0].temperature && mydata.associates[0].heartrate.reading ? `${mydata.associates[0].heartrate.reading} bpm` : ''}`);
        setHeartrateBaseline(`${mydata.associates[0].baseline && mydata.associates[0].baseline.heartrate && mydata.associates[0].baseline.heartrate.nominal ? `${mydata.associates[0].baseline.heartrate.nominal.toFixed(1)} bpm` : ''}`);
        setOxygen(`${mydata.associates[0].temperature && mydata.associates[0].oxygen.reading ? `${mydata.associates[0].oxygen.reading}%` : ''}`);
        setOxygenBaseline(`${mydata.associates[0].baseline && mydata.associates[0].baseline.oxygen && mydata.associates[0].baseline.oxygen.nominal ? `${mydata.associates[0].baseline.oxygen.nominal.toFixed(1)}%` : ''}`);
        let vitals = '';
        if (mydata.associates[0].temperature && mydata.associates[0].temperature.reading) {
          vitals = `Temperature ${mydata.associates[0].temperature.reading} °F`;
          if (mydata.associates[0].baseline && mydata.associates[0].baseline.temperature && mydata.associates[0].baseline.temperature.nominal) {
            vitals += `\tBaseline ${mydata.associates[0].baseline.temperature.nominal.toFixed(1)} °F\r\n`;
          } else {
            vitals += '\tBaseline °F\r\n';
          }
        }
        if (mydata.associates[0].heartrate && mydata.associates[0].heartrate.reading) {
          vitals += `Heartrate ${mydata.associates[0].heartrate.reading} bpm`;
          if (mydata.associates[0].baseline && mydata.associates[0].baseline.heartrate && mydata.associates[0].baseline.heartrate.nominal) {
            vitals += `\tBaseline ${mydata.associates[0].baseline.heartrate.nominal.toFixed(1)} bpm\r\n`;
          } else {
            vitals += '\tBaseline bpm\r\n';
          }
        }
        if (mydata.associates[0].oxygen && mydata.associates[0].oxygen.reading) {
          vitals += `Oxygen ${mydata.associates[0].oxygen.reading} %`;
          if (mydata.associates[0].baseline && mydata.associates[0].baseline.oxygen && mydata.associates[0].baseline.oxygen.nominal) {
            vitals += `\tBaseline ${mydata.associates[0].baseline.oxygen.nominal.toFixed(1)} %\r\n`;
          } else {
            vitals += '\tBaseline %\r\n';
          }
        }
        if (mydata.associates[0].hydration && mydata.associates[0].hydration.reading) {
          vitals += `Hydration ${mydata.associates[0].hydration.reading} %`;
          if (mydata.associates[0].baseline && mydata.associates[0].baseline.hydration && mydata.associates[0].baseline.hydration.nominal) {
            vitals += `\tBaseline ${mydata.associates[0].baseline.hydration.nominal.toFixed(1)} %\r\n`;
          } else {
            vitals += '\tBaseline %\r\n';
          }
        }
        setVitals(vitals);
        if (mydata && mydata.associates && mydata.associates.length >= 1) {
          setAssociate(mydata.associates[0]);
        } else {
          setAssociate({});
        }
        if (mydata.associates[0].latlng && mydata.associates[0].latlng.latitude !== 0 && mydata.associates[0].latlng.longitude !== 0) {
          setLat(mydata.associates[0].latlng.latitude.toString());
          setLng(mydata.associates[0].latlng.longitude.toString());
          setDetails(false);
        }
        if (mydata.associates[0].environment < 0) {
          setEnvColor('e-outline e-info');
        } else if (mydata.associates[0].environment === '' || mydata.associates[0].environment < 25) {
          setEnvColor('e-outline e-success');
        } else if (mydata.associates[0].environment < 50) {
          setEnvColor('e-outline e-info');
        } else if (mydata.associates[0].environment < 80) {
          setEnvColor('e-outline e-warning');
        } else if (mydata.associates[0].environment && mydata.associates[0].environment.length > 0) {
          setEnvColor('e-outline e-error');
        } else {
          setEnvColor('e-outline');
        }
        // setAssociateId(mydata.associates[0]._id);
        // setAssociate(mydata.associates[0]);
        setData(mydata);
        if (mydata.associates && mydata.associates.length >= 1) {
          setAssociate(mydata.associates[0]);
          setCurrentAssoicate(mydata.associates[0].name);
        } else {
          DialogUtility.alert(`Search Associate was not found ${currentAssociate}!`);
        }
      } else if (currentAssociate) {
        setAssociate({});
        setDuressColor('transparent');
        setRisk('');
        setEnvironment('');
        setName('');
        setDevice('');
        setMobile('');
        setEmail('');
        setReportsTo('');
        setAddress('');
        setAddress1('');
        setCity('');
        setState('');
        setZip('');
        setBundle('');
        setRefresh(5);
        setJobTask('');
        setOrganization('');
        setEmployeeImage('https://monaco.zackat.com/blank.png');
        setLanguage('en-US');
        setEngineering(false);
        setManagers([]);
        setAge('');
        setDob('');
        setSMSOptin(false);
        setEmailOptin(false);
        setGender('');
        DialogUtility.alert(`Search Associate not found ${currentAssociate}!`);
      }
      setLoading(false);
    };
    associateFetch();
  }, [currentAssociate, duressColor]);

  const { collapseConfiguration, setCollapseConfiguration } = useStateContext();
  useEffect(() => {
    if (cfgDialog !== true) {
      setCfgDialog(true);
      setReload(!reload);
    }
  }, [collapseConfiguration]);

  function formatPhoneNumber(phoneNumberString) {
    if (phoneNumberString.length <= 0) {
      return null;
    }
    if (phoneNumberString.length === 10) {
      phoneNumberString = `1${phoneNumberString}`;
    }
    const cleaned = (`${phoneNumberString}`).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }
  const orgData = [];
  const langParams = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(langData),
      fields: { value: 'id', text: 'value' },
      query: new Query(),
    },
  };
  const teamParams = {
    params: {
      actionComplete: () => false,
      allowFiltering: true,
      dataSource: new DataManager([
        { TeamDescr: 'Team 1', id: '1' },
        { TeamDescr: 'Team 2', id: '2' },
        { TeamDescr: 'Team 3', id: '3' },
      ]),
      fields: { text: 'TeamDescr', value: 'id' },
      query: new Query(),
    },
  };
  function handleChange(e) {
    e.preventDefault();
    const filedata = new FormData();
    const imagedata = e.target.files[0];
    filedata.append('userfile', imagedata);
    if (associateid !== '' && associateid !== 'add_associate') {
      filedata.append('_id', associateid);
      filedata.append('fileName', e.target.files[0].name);
      setAssociateId('');
      setPatientId('');
    } else {
      return;
    }
    fetch(`${REACT_APP_API_ENDPOINT}/fileup`, {
      method: 'POST',
      headers: {
        Authorization: `JWTToken ${usr.token}`,
      },
      body: filedata,
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // window.location.reload();
        // setReload(!reload);
        e.target.value = null;
        setTimeout(setAssociateId(e.target.id), 2000);
        setPatientId(e.target.id);
      })
      .catch((error) => {
        DialogUtility.alert('An error has occured during Insert!');
      });
  }
  function removePhoto(e) {
    let removeData = null;
    e.preventDefault();
    if (associate._id === e.target.id) {
      removeData = associate;
    }
    if (removeData == null || confirm(`Remove photo for ${associate.name}?`) === false) {
      return;
    }
    if (removeData !== null) {
      fetch(`${REACT_APP_API_ENDPOINT}/fileup`, {
        method: 'DELETE',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
        },
        body: JSON.stringify(removeData),
      })
        .then((response) => response.json())
        .then((responseJson) => {
          setAssociateId('');
          setPatientId('');
          setReload(!reload);
        })
        .catch((error) => {
          DialogUtility.alert('An error has occured during Removal!');
        });
    }
  }

  useEffect(() => {
    const handleResize = () => setScreenSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
      setName(currentAssociate);
      setAssociateId('');
      setPatientId('');
      setAssociate(null);
      setEvents(true);
      setAmapActive(false);
    };
  }, []);
  useEffect(() => {
    const qid = searchParams.get('id');
    const name = searchParams.get('name');
    if (qid && qid.length > 0 && qid !== 'null') {
      if (name && name.length > 0) {
        // localStorage.setItem('currentAssociate', name);
        // setCurrentAssoicate(name);
        setName(name);
      }
      setAssociateId(qid);
      setPatientId(qid);
      setGroupLazy(false);
    }
    return () => {
      setAssociateId('');
      setGroupLazy(true);
    };
  }, []);
  const customiseCell = (args) => {
    if (args.column.field === 'Risk') {
      let tflag = '';
      let oflag = '';
      let hflag = '';
      let bpflag = '';
      let hrflag = '';
      let hrvflag = '';
      if (args.data.temperature && args.data.temperature.alert && args.data.temperature.alert !== '') {
        tflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.heartrate && args.data.heartrate.alert && args.data.heartrate.alert !== '') {
        hrflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.bloodpressure && args.data.bloodpressure.alert && args.data.bloodpressure.alert !== '') {
        bpflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.oxygen && args.data.oxygen.alert && args.data.oxygen.alert !== '') {
        oflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.hydration && args.data.hydration.alert && args.data.hydration.alert !== '') {
        hflag = '<font color="red">&#10003;</font>';
      }
      if (args.data.hrv && args.data.hrv.alert && args.data.hrv.alert !== '') {
        hrvflag = '<font color="red">&#10003;</font>';
      }
      // const temp = args.data.temperature.reading;
      // const hydration = args.data.hydration.reading;
      let set = false;
      let riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th bgcolor="cyan"><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
      if (args.data.risk < 0) {
        // args.cell.classList.add('riskbelow-30');
        args.cell.classList.add('rowcellblue');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th bgcolor="cyan"><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else if (args.data.risk === '' || args.data.risk < 25) {
        // args.cell.classList.add('riskbelow-30');
        args.cell.classList.add('rowcellgrn');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font><th><th  bgcolor="cyan"><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else if (args.data.risk < 50) {
        // args.cell.classList.add('riskbelow-80');
        args.cell.classList.add('rowcellylw');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font><th><th bgcolor="cyan"><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else if (args.data.risk < 80) {
        args.cell.classList.add('rowcellorn');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font><th><th bgcolor="cyan"><font color="orange">ELEVATED</font></th><th><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      } else {
        // args.cell.classList.add('riskabove-80');
        args.cell.classList.add('rowcellred');
        riskLevel = '<table class="biotable" style="width: 100%"><tbody><tr><th><font color="blue">HYPO</font></th><th><font color="green">BASELINE</font></th><th><font color="yellow">MODERATE</font></th><th><font color="orange">ELEVATED</font><th><th bgcolor="cyan"><font color="red">SEVERE</font></th></tr></tbody></table>';
        set = true;
      }
      // Universal AQI
      // Code: uaqi
      // Pollutants: "co", "no2", "o3", "pm10", "pm25", "so2"
      // 100 - 80 Excellent air quality
      // 79 - 60 Good air quality
      // 59 - 40 Moderate air quality
      // 39 - 20 Low air quality
      // 19 - 1 Poor air quality
      // 0 Poor air quality

      if (!set && args.data.environment < 20) {
        args.cell.classList.add('aqi20');
      } else if (!set && args.data.environment < 40) {
        args.cell.classList.add('aqi40');
      } else if (!set && args.data.environment < 60) {
        args.cell.classList.add('aqi60');
      } else if (!set && args.data.environment < 80) {
        args.cell.classList.add('aqi80');
      } else if (!set) {
        args.cell.classList.add('aqi100');
      }
      let bhrv = '';
      let bhr = '';
      let btemp = '';
      let boxy = '';
      let bhyd = '';
      if (args.data.baseline && args.data.baseline.hrv && args.data.baseline.hrv.nominal) {
        bhrv = args.data.baseline.hrv.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.heartrate && args.data.baseline.heartrate.nominal) {
        bhr = args.data.baseline.heartrate.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.temperature && args.data.baseline.temperature.nominal) {
        btemp = args.data.baseline.temperature.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.oxygen && args.data.baseline.oxygen.nominal) {
        boxy = args.data.baseline.oxygen.nominal.toFixed(1);
      }
      if (args.data.baseline && args.data.baseline.hydration && args.data.baseline.hydration.nominal) {
        bhyd = args.data.baseline.hydration.nominal.toFixed(1);
      }

      const thistooltip = new Tooltip({
        width: '400px',
        height: '200px',
        // <img src=${heartrate} style="display: inline-block;" width="30px" height="30px" />
        // ${args.data.bloodpressure ? args.data.bloodpressure.reading : ''}<sub class="supsm">sys/dia</sub>${bpflag}
        content: `<h1 style="text-align: center;">${args.data.name ? args.data.name.toUpperCase() : ''}: BIOMETRICS</h1><table class="biotable"><tbody><tr><th colspan="2">${riskLevel}</th><tr><td class="biometricsgrn"><sup class="supsm">hr</sup>${args.data.heartrate && args.data.heartrate.reading ? args.data.heartrate.reading : ''}<sub class="supsm">bpm</sub>${hrflag}<sup class="supsm">(${bhr})</sup></td><td class="biometricsltgrn">
      <sup class="supsm">hrv</sup>${args.data.hrv && args.data.hrv.reading ? args.data.hrv.reading : ''}<sub class="supsm">ms</sub>${hrvflag}<sup class="supsm">(${bhrv})</sup></td></tr><tr><td class="biometricsorn"><sub class="supsm">O<sup  class="supsm">2</sup></sub>${args.data.oxygen && args.data.oxygen.reading ? args.data.oxygen.reading : ''}<sub class="supsm">%</sub>${oflag}<sup class="supsm">(${boxy})</sup></td><td class="biometricsylw"><sup class="supsm">temp</sup>${args.data.temperature && args.data.temperature.reading ? args.data.temperature.reading : ''}<sub class="supsm">°F</sub>${tflag}<sup class="supsm">(${btemp})</sup></td></tr><tr><td class="biometricsblue"><sup class="supsm">hyd</sup>${args.data.hydration && args.data.hydration.reading ? args.data.hydration.reading : ''}<sub class="supsm">%</sub>${hflag}<sup class="supsm">(${bhyd})</sup></td><td class="biometricscyn"></td></tr></tbody></table>`,
      });
      thistooltip.appendTo(args.cell);
    }
    /*
      switch (args.column.index) {
        case 1:
          args.cell.classList.add('rowcellgrn');
          break;
        case 2:
          args.cell.classList.add('rowcellgrn');
          break;
        case 3:
          if (temp >= 101) {
            // args.cell.classList.add('below-30');
            args.cell.classList.add('rowcellgrn');
          } else if (temp > 99 && temp < 101) {
            // args.cell.classList.add('below-80');
            args.cell.classList.add('rowcellorn');
          }
          break;
        case 6:
          if (hydration <= 30) {
            args.cell.classList.add('rowcellred');
            // args.cell.classList.add('below-30');
          } else if (hydration > 30 && hydration < 70) {
            // args.cell.classList.add('below-80');
            args.cell.classList.add('rowcellylw');
          } else {
            // args.cell.classList.add('above-80');
            args.cell.classList.add('rowcellgrn');
          }
          break;
        default:
          args.cell.classList.add('rowcellgrn');
          break;
      }
      */
  };
  function recordingDevice(e) {
    if (e.target.itemData.value === 'na') {
      return;
    }
    setSelectedAudioOption(e.target.itemData.value);

    if (!associate) {
      DialogUtility.alert('No associate selected, or invalid state');
      return;
    }
    const b = { device: associate.device, name: associate.name };
    const message = `"audio": "${e.target.itemData.value}"`;
    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        // The added/edited data will be saved in the Grid
        DialogUtility.alert('audio request sent');
        setSelectedAudioOption('na');
      })
      .catch((error) => {
        console.error(error);
      });
  }
  function smsDevice(e) {
    if (!e) {
      return;
    }
    const b = associate;
    let cmd = e.target.itemData.value;
    setSelectedOption(cmd);
    let message = '';
    if (cmd == 'na') {
      return;
    }
    if (cmd.length > 0 && cmd !== '""') {
      message = cmd;
    } else {
      message = prompt(`What SMS would you like to send to ${b.device} (${b.name})?`, '');
      cmd = message;
    }
    if (!message || message.length === 0) {
      return;
    }

    const payload = { inventory: b, message };
    fetch(`${REACT_APP_API_ENDPOINT}/jasper`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `JWTToken ${usr.token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        DialogUtility.alert(`Success ${cmd}`);
        setSelectedOption('na');
        // The added/edited data will be saved in the Grid
      })
      .catch((error) => {
        console.error(error);
      });
  }
  function dialogOK(f, e) {
    dialogInstance.hide();
    if (f === 'recording') {
      recordingDevice(e);
    } else if (f === 'sms') {
      smsDevice(e);
    }
    /*
    else if (f === 'mute') {
      silenceDevice(true);
    } else if (f === 'unmute') {
      silenceDevice(false);
    }
    */
  }
  useEffect(() => {
    // Saves changes to localStorage every time the state changes
    localStorage.setItem('currentAssociate', currentAssociate);
  }, [currentAssociate]);
  function dialogClick(f, hdr, content, e) {
    let ok = null;
    if (f !== 'na') {
      ok = { text: 'OK', click: () => { dialogOK(f, e); } };
      if (!associate || !associate.device || associate.device.length === 0) {
        dialogClick('na', 'Associate Row', 'No associate selected', null);
        return;
      }
    }

    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }

  useEffect(() => {
    setBaseColor('cyan');
    if (associate) {
      setRiskColor('e-outline');
      setEnvColor('e-outline');
      if (Number(associate.risk) < 0) {
        setRiskColor('e-outline e-info');
        setHypoColor('cyan');
        setBaseColor('transparent');
        setModerateColor('transparent');
        setElevatedColor('transparent');
        setSevereColor('transparent');
      } else if (associate.risk === '' || Number(associate.risk) < 25) {
        setRiskColor('e-outline e-success');
        setHypoColor('transparent');
        setBaseColor('cyan');
        setModerateColor('transparent');
        setElevatedColor('transparent');
        setSevereColor('transparent');
      } else if (Number(associate.risk) < 50) {
        setRiskColor('e-outline e-info');
        setHypoColor('transparent');
        setBaseColor('transparent');
        setModerateColor('cyan');
        setElevatedColor('transparent');
        setSevereColor('transparent');
      } else if (Number(associate.risk) < 80) {
        setRiskColor('e-outline e-warning');
        setHypoColor('transparent');
        setBaseColor('transparent');
        setModerateColor('transparent');
        setElevatedColor('cyan');
        setSevereColor('transparent');
      } else if (Number(associate.risk) >= 80) {
        setRiskColor('e-outline e-error');
        setHypoColor('transparent');
        setBaseColor('transparent');
        setModerateColor('transparent');
        setElevatedColor('transparent');
        setSevereColor('cyan');
      }
    } else {
      setRiskColor('e-outline');
    }
  }, [currentAssociate, duressColor]);

  function rowClicked() {
    // setAssociateId('');
    setPatientId('');
    setDataChanged(!dataChanged);
  }

  if (loading) {
    setTimeout(() => {
      const e = document.getElementById('loadingdata');
      if (e) {
        e.innerText += '.';
      }
    }, 1000);
    return <p id="loadingdata">Loading </p>;
  }
  if (data.role && data.role.associates) {
    if (!data.role.associates.permissions.includes('Read')) {
      return <p>Not authorized...</p>;
    }
  }

  if (data && data.organization && data.organization.length > 0) {
    data.organization.forEach((org) => {
      const result = orgData.find(({ id }) => id === org._id);
      if (!result || result.value !== '') {
        orgData.push({ id: org._id, value: org.title });
      }
    });
  }
  if (data.recordings) {
    data.recordings.forEach((rec) => {
      const result = langData.find(({ id }) => id === rec.language);
      audioData.push({ value: rec._id, text: `${rec.name} (${result.value})` });
    });
  }

  const organizations = {
    params: {
      actionComplete: () => false,
      dataSource: new DataManager(data.organization),
      fields: { value: '_id', text: 'title' },
      query: new Query(),
    },
  };

  const valuerules = { required: true };
  const uploaderTemplate = (d) => {
    const cl = `icon template-icons sf-icon-${d.type}`;
    return (
      <div>
        <span className="wrapper">
          <span className={cl} />
          <span className="name file-name">{d.name}</span>
        </span>
        <span className="file-size-td file-size">{d.size} bytes</span>
        <span className="e-icons e-file-remove-btn" title="Remove" /> <br />
        <progress id="progressBar" className="progressbar" value="0" max="100" />
        <span className="percent-td percent" />
      </div>
    );
  };
  //          to="https://scribehow.com/viewer/Associate_Page_and_view_Event_Charts_Logs_and_more__hQvYnpJFRzqIpuLbFmD6YQ"

  return (
    <div
      className="m-2 md:m-1 mt-2 p-1 md:p-4 bg-white rounded-3xl zackat-divalh mt-40 w-95"
    >
      <div className="flex">
        <Link
          className="my-link"
          to="/pdf/associate.pdf"
          target="_blank"
        >
          <img src={scribeHow} width={20} height={20} />
        </Link>
        <Header category="Operations" title="Mobile Associate" />
      </div>
      <div id="default_target" className="control-section mt-10">
        <div className="addContainer">
          <ToolbarComponent id="toolbar0" onClick={onToolbarChange} overflowMode="Popup">
            <ItemsDirective>
              <ItemDirective text="Search" template={searchComponent} />
              <ItemDirective type="Separator" />
            </ItemsDirective>
          </ToolbarComponent>
          <ToolbarComponent id="toolbar" onClick={onToolbarChange} overflowMode="Popup">
            <ItemsDirective>
              <ItemDirective text="Raw Events" float="left" prefixIcon="e-justify" visible={boss && !isMobile} disabled={!boss} />
              <ItemDirective type="Separator" visible={boss} />
              <ItemDirective template={actionComponent} visible={boss || smsEnable} disabled={false} />
              <ItemDirective type="Separator" visible={boss || smsEnable} />
              <ItemDirective template={audioComponent} visible={boss || recordings} disabled={false} />
              <ItemDirective type="Separator" visible={boss || recordings} />
            </ItemsDirective>
          </ToolbarComponent>
          <ToolbarComponent id="toolbar2" onClick={onToolbarChange} overflowMode="MultiRow">
            <ItemsDirective>
              <ItemDirective text="Alerts" float="left" visible={boss || crudUpdate} prefixIcon="e-link-remove" />
              <ItemDirective type="Separator" visible={boss || crudUpdate} />
              <ItemDirective text="Location" float="left" prefixIcon="e-location" visible={(boss || locationEnable) && !isMobile} />
              <ItemDirective type="Separator" visible={(boss || locationEnable) && !isMobile} />
              <ItemDirective text="STT" float="left" prefixIcon="e-comments" visible={(boss || sttEnable) && !isMobile} />
              <ItemDirective type="Separator" visible={(boss || sttEnable) && !isMobile} />
              <ItemDirective text="Duress" float="left" prefixIcon="e-pan" visible={(boss || duressEnable) && !isMobile} />
              <ItemDirective type="Separator" visible={(boss || duressEnable) && !isMobile} />
              <ItemDirective text="Devlog" float="left" prefixIcon="e-list-ordered" visible={(boss || devlogEnable) && !isMobile} />
              <ItemDirective type="Separator" visible={(boss || devlogEnable) && !isMobile} />
              <ItemDirective text="Configuration" float="left" visible={(boss || configEnable) && !isMobile} prefixIcon="e-settings" />
              <ItemDirective type="Separator" visible={(boss || configEnable) && !isMobile} />
              <ItemDirective text="Charts" float="left" visible={(boss || chartsEnable) && !isMobile} prefixIcon="e-chart-2d-line-100-stacked-line-with-markers" />
              <ItemDirective type="Separator" visible={(boss || chartsEnable) && !isMobile} />
              <ItemDirective text="Invite" float="left" visible={boss || inviteEnable} prefixIcon="e-callout" />
              <ItemDirective type="Separator" visible={boss || inviteEnable} />
              <ItemDirective text="Schedule" float="left" visible={scheduleEnable} prefixIcon="e-date-range" />
              <ItemDirective type="Separator" visible={scheduleEnable} />
              <ItemDirective text="AI" float="left" visible={boss && !isMobile} prefixIcon="e-assistview-icon" />
              <ItemDirective type="Separator" visible={boss && !isMobile} />
            </ItemsDirective>
          </ToolbarComponent>
        </div>
        {!loading && associate && (
          <DashboardLayoutComponent
            id="associate_dashboard"
            columns={5}
            className="flex"
            ref={dashboardObj}
            cellSpacing={cellSpacing}
            allowResizing
            allowDragging={false}
            enablePersistence={!isMobile}
          >
            <PanelsDirective>
              <PanelDirective id="panel1" minSizeY={1} sizeX={5} sizeY={0} row={0} col={0} content={panel1Content} />
              <PanelDirective id="panel2" minSizeY={1} sizeX={5} sizeY={0} row={1} col={0} content={panel2Content} />
              <PanelDirective id="panel4" minSizeY={1} sizeX={5} sizeY={1} row={2} col={0} content={panel4Content} />
              <PanelDirective id="panel3" minSizeY={2} sizeX={5} sizeY={3} row={3} col={0} content={panel3Content} />
              {!isMobile && <PanelDirective id="panel5" minSizeY={1} sizeX={1} sizeY={3} row={1} col={4} content={panel5Content} />}
            </PanelsDirective>
          </DashboardLayoutComponent>
        )}
      </div>
      {!hideDialog && (
        <DialogComponent
          header={header}
          content={profileTemplate}
          buttons={associateid !== 'add_associate' ? savebuttons : addbuttons}
          width={associateid === 'add_associate' ? '95%' : '90%'}
          height={associateid === 'add_associate' ? '90%' : '90%'}
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => {
            setDialog(!hideDialog);
          }}
          close={() => { setDialog(!hideDialog); }}

        />
      )}
      {!sstEventDialog && (
        <DialogComponent
          header="STT Events"
          content={sstEventTemplate}
          buttons={ssteventsbuttons}
          width="95%"
          height="95%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setSSTEventDialog(!sstEventDialog); }}
          close={() => { setSSTEventDialog(!sstEventDialog); }}
        />
      )}
      {!duressEventDialog && (
        <DialogComponent
          header="Duress Events"
          content={duressEventTemplate}
          buttons={duresseventsbuttons}
          width="95%"
          height="95%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setDuressEventDialog(!duressEventDialog); }}
          close={() => { setDuressEventDialog(!duressEventDialog); }}
        />
      )}
      {associate && !cfgDialog && (
      <DialogComponent
        header="Configuration"
        content={cfgTemplate}
        buttons={cfgbuttons}
        width="95%"
        height="95%"
        isModal
        visible
        closeOnEscape
        showCloseIcon
        onClose={() => { setCfgDialog(true); }}
        close={() => { setCfgDialog(true); }}
      />
      )}
      {boss && !devlogDialog && (
        <DialogComponent
          header="Device Logs"
          content={devlogTemplate}
          buttons={devlogbuttons}
          width="65%"
          height="85%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setDevlogDialog(true); }}
          close={() => { setDevlogDialog(true); }}
        />
      )}
      {!gmapDialog && (
        <DialogComponent
          header="Map Location"
          content={gmapTemplate}
          buttons={gmapbuttons}
          width="65%"
          height="65%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setGMapDialog(true); }}
          close={() => { setGMapDialog(true); }}
        />
      )}
      {!chartsDialog && (
        <DialogComponent
          header="Charts Week View"
          content={chartTemplate}
          buttons={chartbuttons}
          width="65%"
          height="85%"
          isModal
          visible
          closeOnEscape
          showCloseIcon
          onClose={() => { setChartsDialog(true); }}
          close={() => { setChartsDialog(true); }}
        />
      )}
      {!calDialog && (
        <DialogComponent
          header="Associate Schedule"
          content={calTemplate}
          buttons={calbuttons}
          isModal
          visible
          closeOnEscape
          showCloseIcon
          close={() => { setCalDialog(true); }}
        />
      )}
      {isClicked.userFaq && (<PredictorAI dt="Predictive Analysis" associate={associate} />)}
    </div>
  );
};
export default MobileAssociateLayout;
